// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__znkYd","root":"styles_root__plb4v","img":"styles_img__Vekf6","button":"styles_button__0wXWP"};